export default __webpack_public_path__ + "static/media/header-img.c30c6484.png";